import { Link } from 'react-router-dom'
import { Button } from '../ui/button'
import { ModeToggle } from '../layout/ModeToggle'

export default function Navbar() {
  return (
    <header className='sticky top-0 z-50 border-b bg-background/60 backdrop-blur'>
      <div className='mx-auto max-w-7xl px-4 py-3 flex items-center justify-between'>
        <Link to='/' className='flex items-center gap-2'>
          <span>
            {/* Mode clair */}
            <img
              src='/logo_mogesapp_light.png'
              alt='MOGESAPP'
              className='h-6 w-6 dark:hidden'
              loading='eager'
            />
            {/* Mode sombre */}
            <img
              src='/logo_mogesapp_dark.png'
              alt='MOGESAPP'
              className='h-6 w-6 hidden dark:block'
              loading='eager'
            />
          </span>
          <span className='text-xl text-primary font-extrabold tracking-tight'>
            MOGESAPP
          </span>
          <span className='rounded-full border px-2 py-0.5 text-[10px] text-muted-foreground'>
            v4
          </span>
        </Link>

        <nav className='hidden md:flex items-center gap-6 text-sm'>
          <Link to='/pricing' className='hover:text-foreground'>
            Tarifs
          </Link>
          <Link to='/documentation' className='hover:text-foreground'>
            Documentation
          </Link>
          <Link to='/about' className='hover:text-foreground'>
            À propos
          </Link>
        </nav>

        <div className='flex items-center gap-3'>
          <Link to='/login' className='text-sm'>
            Connexion
          </Link>
          <Link to='/register?redirect=/dashboard'>
            <Button size='sm' className='font-semibold'>
              Essai gratuit
            </Button>
          </Link>
          <ModeToggle />
        </div>
      </div>
    </header>
  )
}
